var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoIntensity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.619,
    height: 17.875,
    viewBox: "0 0 20.619 17.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10760",
    "data-name": "Group 10760",
    transform: "translate(128.893 169.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6922",
    "data-name": "Path 6922",
    d: "M134.524-160.105q0,3.4,0,6.8a2.052,2.052,0,0,1-1.535,2.031,2.223,2.223,0,0,1-.529.071c-.565.009-1.131.008-1.7,0a2.059,2.059,0,0,1-2.079-2.088q-.006-6.847,0-13.693a2.058,2.058,0,0,1,2.085-2.082q.837-.007,1.674,0a2.058,2.058,0,0,1,2.079,2.088C134.528-164.684,134.524-162.395,134.524-160.105Z",
    transform: "translate(-242.799 0)",
    fill: "#cb3d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6923",
    "data-name": "Path 6923",
    d: "M-.109-95.483q0-2.426,0-4.852a2.064,2.064,0,0,1,2.169-2.17c.523,0,1.045,0,1.568,0a2.053,2.053,0,0,1,2.1,2.105q.005,4.917,0,9.833a2.06,2.06,0,0,1-2.1,2.109q-.816,0-1.632,0a2.063,2.063,0,0,1-2.1-2.108C-.112-92.206-.109-93.844-.109-95.483Z",
    transform: "translate(-121.396 -62.739)",
    fill: "#cb3d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6924",
    "data-name": "Path 6924",
    d: "M-128.893-30.953q0-1.481,0-2.963a2.056,2.056,0,0,1,2.137-2.157c.587,0,1.174-.013,1.76.009a2.017,2.017,0,0,1,1.937,1.976q.024,3.123,0,6.247a2.035,2.035,0,0,1-1.992,2,16.06,16.06,0,0,1-2.143-.045,2,2,0,0,1-1.7-1.972c0-.022,0-.043,0-.064Q-128.893-29.44-128.893-30.953Z",
    transform: "translate(0 -125.358)",
    fill: "#cb3d82"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIntensity);
export default __webpack_public_path__ + "static/media/ICO-INTENSITY.3a63c16650b28b25873416bd966bf14f.svg";
export { ForwardRef as ReactComponent };